// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QwUc","type":"styles_type__3FaEl","choices":"styles_choices__1hyXL"};